import _ from "lodash";
import { USER_NAME_PROPERTIES } from "Constants";

const getPosts = ({ postsEdges }) => {
  return _.map(postsEdges, item => {
    return item.node;
  });
};

export const getPostsMemoize = _.memoize(
  params => getPosts(params),
  ({ postsEdges }) => {
    return JSON.stringify({
      postsEdges: _.map(postsEdges, ({ node }) => ({
        node: {
          id: node?.id,
          title: node?.title,
          items: _.map(node?.items, ({ item, itemType }) => ({
            itemType,
            item: _.pick(item, ["id"]),
          })),
          createdBy: _.pick(node?.createdBy, [
            "id",
            "profileImage",
            ...USER_NAME_PROPERTIES,
          ]),
          attachments: _.map(node?.attachments, attachment =>
            _.pick(attachment, [
              "id",
              "isRead",
              "name",
              "streamUrl",
              "thumbUrl",
              "title",
              "url",
            ])
          ),
        },
      })),
    });
  }
);
